export const defaultInputConfig = {
  default: {
    label: {
      en: 'Input',
      id: 'Masukan',
    },
    placeholder: 'Input',
    name: 'input',
    form_field_type: 'INPUT_TEXT',
    ui_type: 'INPUT',
    defaultValue: '',
    tooltip: {
      enable: false,
      message: '',
    },
    disabled: false,
  },
  INPUT_DATE: {
    label: {
      en: 'Input Date',
      id: 'Masukan Tanggal',
    },
    placeholder: 'Input',
    name: 'input',
    form_field_type: 'INPUT_TEXT',
    format: 'dd/MM/yyyy',
    ui_type: 'INPUT',
    dateValidation: {
      minDate: {
        fromField: false,
        isToday: false,
        value: '',
      },
      maxDate: {
        fromField: false,
        isToday: false,
        value: null,
      },
    },
    defaultValue: null,
    tooltip: {
      enable: false,
      message: '',
    },
    disabled: false,
  },
  'INPUT_DATETIME-LOCAL': {
    label: {
      en: 'Input Date and Time',
      id: 'Masukan Tanggal dan Waktu',
    },
    placeholder: 'Input',
    name: 'input',
    form_field_type: 'INPUT_TEXT',
    format: 'dd/MM/yyyy HH:mm',
    ui_type: 'INPUT',
    dateValidation: {
      minDate: {
        fromField: false,
        isToday: false,
        value: '',
      },
      maxDate: {
        fromField: false,
        isToday: false,
        value: null,
      },
    },
    defaultValue: null,
    tooltip: {
      enable: false,
      message: '',
    },
    disabled: false,
  },
}
